import React from 'react'
import logo from '../logo.svg'

export const Footer = (props) => {
  return(
    <div class="footer">
      <div class="footer-container">
        <div class="footer-column">
          <img src={logo} class="footer-logo"/>
          <p>We have a global reputation for implementing strategic solutions for our customers. We are Cross-Cloud experts with proficiency in Salesforce Sales, Marketing, Service and Community Clouds as well as Pardot – all delivered with incomparable customer service and a commitment to measurable results.</p>
        </div>
        <div class="footer-column">
          <div class="text-block-3">
            <strong>CONTACT US</strong>
            <br/><br/>Bubblebox®  <br/>#280 1770 Burrard St<br/>Vancouver, British Columbia <br/>V6J 3G7 Canada<br/>888-247-8495<br/>info@bubblebox.cloud<br/>www.bubblebox.cloud</div>
        </div>
      </div>
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js